<template>
  <div class="solution4">
    <div class="banner">
      <div class="w1200">
        <h3>农产品区域公用品牌数字化解决方案</h3>
        <p>通过“两标一品”，打造优势农产品区域公用品牌</p>
      </div>
    </div>
    <div class="container">
      <h3>中国特色农产品优势区创建认定标准</h3>
      <div class="cont">
        <img src="@/assets/mob/images/solution/c_4.jpg" alt="" />
      </div>
    </div>
    <div class="d_footer1">
      <h3>通过“两标一品”，打造优势农产品 区域公用品牌</h3>
      <img src="@/assets/mob/images/solution/c_4_2.png" alt="" />
    </div>
    <div class="d_footer2">
      <h3>龙头企业为核心的农业产业化联合体</h3>
      <p>
        鼓励发展以龙头企业为引领，农民合作社和家庭农场跟进，广大小农户参与，采取订单生产、股份合作的农业产业化联合体
      </p>
      <div class="imgSec">
        <img src="@/assets/mob/images/solution/c_4_3.jpg" alt="" />
      </div>
      <ul class="clear">
        <li class="one border_b">
          农民将土地入股到合作社，合作社将土地托管给大型龙头企业，龙头企业投入技术及资金，政府出相关配套，聘请职业农民实行专业化经营
        </li>
        <li class="two">
          实现农民得保底分红、合作社得服务分红、中化农业得运营分红、职业农民得绩效分红，有效促进了小农户与现代农业的有机衔接
        </li>
      </ul>
      <div
        class="button"
        @click="
          show = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <Dialog
      :show="show"
      :systemId="systemId"
      title="获取最新解决方案"
      @close="show = false"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '3',
      show: false,
    }
  },
}
</script>
<style lang="scss">
@import '~@/assets/mob/css/solution.scss';
</style>
